"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Environment = void 0;
/**
 * The server environment you are running and reporting against.
 * @public
 */
class Environment {
    /**
     * Create a new environment.
     * @param name - The name of the environment. This is for debugging purposes only.
     * @param baseURL - The base URL for requests made with the PFF Inside API.
     * @param apiKey - The API key to use when making requests.
     */
    constructor(name, baseURL, apiKey) {
        this.name = name;
        this.baseURL = baseURL;
        this.apiKey = apiKey;
    }
}
exports.Environment = Environment;
/** Predefined environment for a "QA" environment. */
Environment.qa = new Environment('qa', new URL('https://consumer-api.pff-qa.com'));
/** Predefined environment for a "Production" environment. */
Environment.production = new Environment('production', new URL('https://consumer-api.pff.com'));
/** Predefined environment for a "Testing" environment. */
Environment.testing = new Environment('testing', new URL('https://consumer-api.pff.com'));
/** The default server environment we build against. */
Environment.default = Environment.production;
//# sourceMappingURL=environment.js.map